import { Route, Routes } from 'react-router-dom'
import DocumentPage from './Page'

export default function Documents() {
  return (
    <Routes>
      <Route path="/*" element={<DocumentPage />} />
      <Route path="/:documentId" element={<DocumentPage />} />
    </Routes>
  )
}
